import css from 'styled-jsx/css'

export const styles: any = css`
  .highlighted-link {
    color: var(--theme-primary);
  }
`
